import styled from 'styled-components';

// CSS is from node_modules react-photoswipe-2 v1.3.1 taken because we don't have CSS processor
// added param isMobile for mobile styling
const StyledPhotoSwipe = styled.div<{ isMobile: boolean }>`
  .pswp {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    overflow: hidden;
    touch-action: none;
    z-index: 1500;
    backface-visibility: hidden;
    text-size-adjust: 100%;
    outline: none;
  }

  .pswp * {
    box-sizing: border-box;
  }

  .pswp__container {
    user-select: none;
  }

  .pswp img {
    max-width: none;
    user-select: none;
    position: absolute;
    left: 0;
    top: 0;
    width: auto;
    height: auto;
  }

  .pswp--animate_opacity {
    opacity: 0.001;
    will-change: opacity;
    transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
  }

  .pswp--open {
    display: block;
  }

  .pswp--zoom-allowed .pswp__img {
    cursor: zoom-in;
  }

  .pswp--zoomed-in .pswp__img {
    cursor: grab;
  }

  .pswp--dragging .pswp__img {
    cursor: grabbing;
  }

  .pswp__bg {
    background: rgba(255, 255, 255, 1); /* customised: background to rgba(255,255,255,1) */
    opacity: 0;
    transform: translateZ(0);
    backface-visibility: hidden;
    will-change: opacity;
    transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
  }

  .pswp__bg,
  .pswp__scroll-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .pswp__scroll-wrap {
    overflow: hidden;
  }

  .pswp__container,
  .pswp__zoom-wrap {
    touch-action: none;
    backface-visibility: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .pswp__zoom-wrap {
    position: absolute;
    width: 100%;
    transform-origin: left top;
    transition: transform 333ms cubic-bezier(0.4, 0, 0.22, 1);
  }

  .pswp--animated-in .pswp__bg,
  .pswp--animated-in .pswp__zoom-wrap {
    transition: none;
  }

  .pswp__item {
    right: 0;
    bottom: 0;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
  }

  .pswp__img--placeholder {
    backface-visibility: hidden;
  }

  .pswp__img--placeholder--blank {
    background: #fff;
  }

  .pswp--ie .pswp__img {
    width: 100%;
    height: auto;
    left: 0;
    top: 0;
  }

  .pswp__error-msg {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    margin-top: -8px;
    color: #ccc;
  }

  .pswp__error-msg a {
    color: #ccc;
    text-decoration: underline;
  }

  .pswp__button {
    width: 44px;
    height: 44px;
    position: relative;
    background: none;
    cursor: pointer;
    overflow: visible;
    appearance: none;
    display: block;
    border: 0;
    padding: 0;
    margin: 0;
    float: right;
    opacity: 0.75;
    transition: opacity 0.2s;
    box-shadow: none;
  }

  .pswp__button,
  .pswp__button--arrow--left:before,
  .pswp__button--arrow--right:before {
    /* customised: removed background and background size rules */
    width: 44px;
    height: 44px;
  }

  .pswp__button:focus,
  .pswp__button:hover {
    opacity: 1;
  }

  .pswp__button:active {
    outline: none;
    opacity: 0.9;
  }

  /* customised: complete definition for button close*/
  .pswp__button--close {
    position: relative;
    background: transparent none;
    color: #333;
    cursor: pointer;
    border-radius: 50%;
    font-size: 0;
    line-height: 0;
    text-indent: -2000rem;
    width: 2.4rem;
    height: 2.4rem;
    margin-left: auto;
  }

  /* customised: complete definition for button close :before */
  .pswp__button--close:before {
    content: '';
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border-style: solid;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    transition: all 400ms;
    background-color: #fff;
    border-width: 2px;
    border-color: #a0a0a0;
    box-sizing: border-box;
  }
  .pswp__button--close:hover:before {
    width: 120%;
    height: 120%;
    margin-left: -10%;
    margin-top: -10%;
    border-color: #333;
  }

  /* customised: complete definition for button close :after */
  .pswp__button--close:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-image: url('data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+Y2xvc2VfbGc8L3RpdGxlPgo8cGF0aCBkPSJNMjguNzA4IDQuNzA4bC0xLjQxNi0xLjQxNi0xMS4yOTIgMTEuMjk0LTExLjI5Mi0xMS4yOTQtMS40MTYgMS40MTYgMTEuMjk0IDExLjI5Mi0xMS4yOTQgMTEuMjkyIDEuNDE2IDEuNDE2IDExLjI5Mi0xMS4yOTQgMTEuMjkyIDExLjI5NCAxLjQxNi0xLjQxNi0xMS4yOTQtMTEuMjkyeiI+PC9wYXRoPgo8L3N2Zz4K');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 1.25rem 1.25rem;
    box-sizing: border-box;
  }

  .pswp__ui--over-close .pswp__button--close {
    opacity: 1;
  }

  /* customised: complete rules for button arrrow left and button arrow right */
  .pswp__button--arrow--left,
  .pswp__button--arrow--right {
    width: 5rem;
    height: 9rem;
    margin: 0;
    padding: 0.4em 0;
    position: absolute;
    top: 50%;
    background-color: rgba(255, 255, 255, 0.4);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 50% auto;
    line-height: 1;
    cursor: pointer;
    transition: all 400ms ease-in-out;
  }

  /* customised: added arrow as background image */
  .pswp__button--arrow--left {
    left: 0;
    background-image: url('data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+YXJyX2xlZnRfbGc8L3RpdGxlPgo8cGF0aCBkPSJNMjEuMDg5IDUuMDQ4YzAuNTc5LTAuOTQxIDAuMjg2LTIuMTczLTAuNjU1LTIuNzUycy0yLjE3My0wLjI4Ni0yLjc1MiAwLjY1NWwtOC4wMjYgMTMuMDM5IDcuOTA1IDEzLjA0NmMwLjU3MiAwLjk0NSAxLjgwMiAxLjI0NiAyLjc0NyAwLjY3NHMxLjI0Ni0xLjgwMiAwLjY3NC0yLjc0N2wtNi42MzktMTAuOTU3IDYuNzQ1LTEwLjk1OXoiPjwvcGF0aD4KPC9zdmc+Cg==');
  }

  /* customised: added arrow as background image */
  .pswp__button--arrow--right {
    right: 0;
    background-image: url('data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgo8dGl0bGU+YXJyX3JpZ2h0X2xnPC90aXRsZT4KPHBhdGggZD0iTTEwLjQwMyAyNi45NjRjLTAuNTcyIDAuOTQ1LTAuMjcxIDIuMTc1IDAuNjc0IDIuNzQ3czIuMTc1IDAuMjcxIDIuNzQ3LTAuNjc0bDcuOTA1LTEzLjA0Ni04LjAyNi0xMy4wMzljLTAuNTc5LTAuOTQxLTEuODExLTEuMjM0LTIuNzUyLTAuNjU1cy0xLjIzNCAxLjgxMS0wLjY1NSAyLjc1Mmw2Ljc0NSAxMC45NTktNi42MzkgMTAuOTU3eiI+PC9wYXRoPgo8L3N2Zz4K');
  }

  /* customised: added hover rule for button arrow left and button arrow right*/
  .pswp__button--arrow--left:hover,
  .pswp__button--arrow--right:hover {
    box-shadow: 0 0 10px -3px #000;
    background-color: rgba(255, 255, 255, 0.8);
  }

  /* customised: removed background color from button arrow left and button arrow right*/
  .pswp__button--arrow--left:before,
  .pswp__button--arrow--right:before {
    content: '';
    top: 35px;
    height: 30px;
    width: 32px;
    position: absolute;
  }

  .pswp__button--arrow--left:before {
    left: 6px;
    background-position: -138px -44px;
  }

  .pswp__button--arrow--right:before {
    right: 6px;
    background-position: -94px -44px;
  }

  .pswp__button--share {
    background-position: -44px -44px;
  }

  .pswp__button--fs {
    display: none;
  }

  .pswp--supports-fs .pswp__button--fs {
    display: block;
  }

  .pswp--fs .pswp__button--fs {
    background-position: -44px 0;
  }

  .pswp__button--zoom {
    display: none;
    background-position: -88px 0;
  }

  .pswp--zoomed-in .pswp__button--zoom {
    background-position: -132px 0;
  }

  .pswp--touch .pswp__button--arrow--left,
  .pswp--touch .pswp__button--arrow--right {
    visibility: hidden;
  }

  .pswp__counter,
  .pswp__share-modal {
    user-select: none;
  }

  .pswp__share-modal {
    display: block;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 10px;
    position: absolute;
    z-index: 1600;
    opacity: 0;
    transition: opacity 0.25s ease-out;
    backface-visibility: hidden;
    will-change: opacity;
  }

  .pswp__share-modal--hidden {
    display: none;
  }

  .pswp__share-tooltip {
    z-index: 1620;
    position: absolute;
    background: #fff;
    top: 56px;
    border-radius: 2px;
    display: block;
    width: auto;
    right: 44px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    transform: translateY(6px);
    transition: transform 0.25s;
    backface-visibility: hidden;
    will-change: transform;
  }

  .pswp__share-tooltip a {
    display: block;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 18px;
  }

  .pswp__share-tooltip a,
  .pswp__share-tooltip a:hover {
    color: #000;
    text-decoration: none;
  }

  .pswp__share-tooltip a:first-child {
    border-radius: 2px 2px 0 0;
  }

  .pswp__share-tooltip a:last-child {
    border-radius: 0 0 2px 2px;
  }

  .pswp__share-modal--fade-in {
    opacity: 1;
  }

  .pswp__share-modal--fade-in .pswp__share-tooltip {
    transform: translateY(0);
  }

  .pswp--touch .pswp__share-tooltip a {
    padding: 16px 12px;
  }

  a.pswp__share--facebook:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    top: -12px;
    right: 15px;
    border: 6px solid transparent;
    border-bottom-color: #fff;
    pointer-events: none;
  }

  a.pswp__share--facebook:hover {
    background: #3e5c9a;
    color: #fff;
  }

  a.pswp__share--facebook:hover:before {
    border-bottom-color: #3e5c9a;
  }

  a.pswp__share--twitter:hover {
    background: #55acee;
    color: #fff;
  }

  a.pswp__share--pinterest:hover {
    background: #ccc;
    color: #ce272d;
  }

  a.pswp__share--download:hover {
    background: #ddd;
  }

  .pswp__counter {
    color: #444;
    position: static;
    height: auto;
    font-size: 1rem;
    left: 0;
    top: 0;
    line-height: 44px;
    opacity: 0.75;
    padding: 0 10px;
  }

  .pswp__caption {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 44px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  .pswp__caption small {
    font-size: 11px;
    color: #bbb;
  }

  .pswp__caption__center {
    text-align: left;
    max-width: 420px;
    margin: 0 auto;
    font-size: 13px;
    padding: 10px;
    line-height: 20px;
    color: #ccc;
  }

  .pswp__caption--empty {
    display: none;
  }

  .pswp__caption--fake {
    visibility: hidden;
  }

  .pswp__preloader {
    width: 44px;
    height: 44px;
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -22px;
    opacity: 0;
    transition: opacity 0.25s ease-out;
    will-change: opacity;
    direction: ltr;
  }

  .pswp__preloader__icn {
    width: 20px;
    height: 20px;
    margin: 12px;
  }

  .pswp__preloader--active {
    opacity: 1;
  }

  .pswp--css_animation .pswp__preloader__icn {
    background: none;
    opacity: 0.75;
    width: 14px;
    height: 14px;
    position: absolute;
    left: 15px;
    top: 15px;
    margin: 0;
  }

  .pswp__preloader--active .pswp__preloader__icn {
    /* customised: added loader gif as base64 encoded */
    background: url('data:image/gif;base64,R0lGODlhFAAUAPMIAIeHhz8/P1dXVycnJ8/Pz7e3t5+fn29vb////wAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwAAAAAFAAUAEAEUxDJSatFxtwaggWAdIyHJAhXoRYSQUhDPGx0TbmujahbXGWZWqdDAYEsp5NupLPkdDwE7oXwWVasimzWrAE1tKFHErQRK8eL8mMUlRBJVI307uoiACH5BAUHAAgALAEAAQASABIAAAROEMkpS6E4W5upMdUmEQT2feFIltMJYivbvhnZ3R0A4NMwIDodz+cL7nDEn5CH8DGZh8MtEMBEoxkqlXKVIgQCibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpjaE4W5spANUmFQX2feFIltMJYivbvhnZ3d1x4BNBIDodz+cL7nDEn5CH8DGZAsFtMMBEoxkqlXKVIgIBibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpAaA4W5vpOdUmGQb2feFIltMJYivbvhnZ3Z0g4FNRIDodz+cL7nDEn5CH8DGZgcCNQMBEoxkqlXKVIgYDibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpz6E4W5upENUmAQD2feFIltMJYivbvhnZ3V0Q4JNhIDodz+cL7nDEn5CH8DGZg8GtUMBEoxkqlXKVIggEibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkphaA4W5tpCNUmHQf2feFIltMJYivbvhnZ3d0w4BMAIDodz+cL7nDEn5CH8DGZBMLNYMBEoxkqlXKVIgoFibbK9YLBYvLtHH5K0J0IACH5BAUHAAgALAEAAQASABIAAAROEMkpQ6A4W5vpGNUmCQL2feFIltMJYivbvhnZ3R1B4NNxIDodz+cL7nDEn5CH8DGZhcINAMBEoxkqlXKVIgwGibbK9YLBYvLtHH5K0J0IACH5BAUHAAcALAEAAQASABIAAANCeLo6wzA6FxkhbaoQ4L3ZxnXLh0EjWZ4RV71VUcCLIByyTNt2PsO8m452sBGJBsNxkUwuD03lAQBASqnUJ7aq5UYSADs=')
      0 0 no-repeat;
  }

  .pswp--css_animation .pswp__preloader--active {
    opacity: 1;
  }

  .pswp--css_animation .pswp__preloader--active .pswp__preloader__icn {
    animation: clockwise 0.5s linear infinite;
  }

  .pswp--css_animation .pswp__preloader__donut {
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    border: 2px solid #fff;
    border-radius: 50%;
    border-left-color: transparent;
    border-bottom-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
    background: none;
    margin: 0;
  }

  .pswp--css_animation .pswp__preloader--active .pswp__preloader__donut {
    animation: donut-rotate 1s cubic-bezier(0.4, 0, 0.22, 1) infinite;
  }

  .pswp--css_animation .pswp__preloader__cut {
    position: relative;
    width: 7px;
    height: 14px;
    overflow: hidden;
  }

  @media screen and (max-width: 1024px) {
    .pswp__preloader {
      position: relative;
      left: auto;
      top: auto;
      margin: 0;
      float: right;
    }
  }

  @keyframes clockwise {
    0% {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(1turn);
    }
  }

  @keyframes donut-rotate {
    0% {
      transform: rotate(0);
    }
    50% {
      transform: rotate(-140deg);
    }
    to {
      transform: rotate(0);
    }
  }

  .pswp__ui {
    visibility: visible;
    opacity: 1;
    z-index: 1550;
  }

  /* customised: complete definition for top-bar */
  .pswp__top-bar {
    background-color: rgba(255, 255, 255, 0.3);
    height: auto;
    ${({ isMobile }) => (isMobile ? 'padding: .4rem .8rem;' : 'padding: .8rem 2rem;')}
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1rem;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  /* customised: removed button arrow left and button arrow right from ruleset */
  .pswp__caption,
  .pswp__top-bar {
    backface-visibility: hidden;
    will-change: opacity;
    transition: opacity 333ms cubic-bezier(0.4, 0, 0.22, 1);
  }

  .pswp--has_mouse .pswp__button--arrow--left,
  .pswp--has_mouse .pswp__button--arrow--right {
    visibility: visible;
  }

  .pswp__ui--fit .pswp__caption,
  .pswp__ui--fit .pswp__top-bar {
    background-color: rgba(255, 255, 255, 0.3);
  }

  .pswp__ui--idle .pswp__button--arrow--left,
  .pswp__ui--idle .pswp__button--arrow--right,
  .pswp__ui--idle .pswp__top-bar {
    opacity: 0;
  }

  .pswp__ui--hidden .pswp__button--arrow--left,
  .pswp__ui--hidden .pswp__button--arrow--right,
  .pswp__ui--hidden .pswp__caption,
  .pswp__ui--hidden .pswp__top-bar {
    opacity: 0.001;
  }

  .pswp__ui--one-slide .pswp__button--arrow--left,
  .pswp__ui--one-slide .pswp__button--arrow--right,
  .pswp__ui--one-slide .pswp__counter {
    display: none;
  }

  .pswp__element--disabled {
    display: none;
  }

  .pswp--minimal--dark .pswp__top-bar {
    background: none;
  }
`;

export default StyledPhotoSwipe;
